import { FC } from 'react';
import { SectionHeading } from '../SectionHeading';
import { PasswordSettingsForm } from './PasswordSettingsForm';

export const PasswordSettingsSection: FC = () => {
  return (
    <div className="flex flex-col gap-6">
      <SectionHeading>Password Settings</SectionHeading>

      <PasswordSettingsForm />
    </div>
  );
};
